import * as React from 'react'
import * as convertTime from 'utils/convert-time'
import * as T from 'components/ui/typography'

import Routes from 'utils/routes'
import Link from 'next/link'
import SectionBarChart from 'components/shared/charts/section-bar-chart'
import { getFromStorage } from 'utils/local-storage'
import Button from 'components/shared/button'
import useDeleteSimulation from 'hooks/simulations/delete-simulation'

import { analytics } from 'utils/analytics'
import IconButton from 'components/shared/icon-button'
import { Trash2 } from 'lucide-react'

interface PropsSuspendedSim {
    simulation: Simulation
}

const SuspendedSimCard: React.FC<PropsSuspendedSim> = ({ simulation }) => {
    const deleteSimulation = useDeleteSimulation()

    const data = getFromStorage('simulation_' + simulation._id)

    const handleTrack = () => {
        analytics.track('simulation_continue', {
            numbers_of_Question: simulation.questions_number,
            category: simulation.category,
        })
    }

    const textDate = convertTime.getCreationDateFromSimulation(simulation)

    return (
        <div className="border flex-1 rounded-sm ">
            <div className="flex flex-col">
                <div className="flex justify-between items-center">
                    <div className="flex-1 p-3">
                        <T.Small className="font-[Manrope] line-clamp-1">{simulation.name}</T.Small>

                        <T.Muted className="capitalize text-sm">{textDate}</T.Muted>
                    </div>

                    <IconButton onClick={() => deleteSimulation(simulation._id)} className="mx-1 mr-1">
                        <Trash2 className="text-error" />
                    </IconButton>
                </div>
            </div>
            <hr />
            <div className=" w-full">
                <SectionBarChart dataFromState={data} test={simulation} />
            </div>
            <hr />
            <div className="flex py-1 justify-center">
                <Link
                    href={{
                        pathname: Routes.SimulationsPage,
                        query: {
                            id: simulation._id,
                            fetchingMode: 'GET',
                            mode: 'FLEX',
                            env: simulation.category === 'TOLC-MED' ? 'TESTYTOLC' : 'TESTY',
                        },
                    }}
                    className="w-full px-3"
                    passHref>
                    <Button onClick={handleTrack} variant="link" className="uppercase w-full ">
                        Continua
                    </Button>
                </Link>
            </div>
        </div>
    )
}

export default SuspendedSimCard
